import Vue from 'vue';
import VueRouter from 'vue-router';
import Wenju from '@/pages/wenju.vue';
import Page_junbishangcheng from '@/pages/Page_junbishangcheng.vue';
import Bangongwenju from '@/pages/bangongwenju.vue';
import Wenfangsibao from '@/pages/wenfangsibao.vue';
import Huajuhuacai from '@/pages/huajuhuacai.vue';
import Jisuanqi from '@/pages/jisuanqi.vue';
import Xueshengwenju from '@/pages/xueshengwenju.vue';
import Wenjushouna from '@/pages/wenjushouna.vue';
import Bianqian from '@/pages/bianqian.vue';
import Page_shangpinxiangqingyemianbeifen from '@/pages/Page_shangpinxiangqingyemianbeifen.vue';
import Page_shangpinxiangqingyemian from '@/pages/Page_shangpinxiangqingyemian.vue';
import Page_huiyuankaitongyemianbeifen_3 from '@/pages/Page_huiyuankaitongyemianbeifen_3.vue';
import Page_huiyuankaitongyemianbeifen_2 from '@/pages/Page_huiyuankaitongyemianbeifen_2.vue';
import shangjiaruzhu from '@/pages/shangjiaruzhu.vue'
import ruzhuchenggong from '@/pages/ruzhuchenggong.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/ruzhuchenggong',
    name: 'ruzhuchenggong',
    component: ruzhuchenggong,
  },
  {
    path: '/shangjiaruzhu',
    name: 'shangjiaruzhu',
    component: shangjiaruzhu,
  },
  {
    path: '/',
    name: 'wenju',
    component: Wenju,
  },
  {
    path: '/Page_junbishangcheng',
    name: 'Page_junbishangcheng',
    component: Page_junbishangcheng,
  },
  {
    path: '/bangongwenju',
    name: 'bangongwenju',
    component: Bangongwenju,
  },
  {
    path: '/wenfangsibao',
    name: 'wenfangsibao',
    component: Wenfangsibao,
  },
  {
    path: '/huajuhuacai',
    name: 'huajuhuacai',
    component: Huajuhuacai,
  },
  {
    path: '/jisuanqi',
    name: 'jisuanqi',
    component: Jisuanqi,
  },
  {
    path: '/xueshengwenju',
    name: 'xueshengwenju',
    component: Xueshengwenju,
  },
  {
    path: '/wenjushouna',
    name: 'wenjushouna',
    component: Wenjushouna,
  },
  {
    path: '/bianqian',
    name: 'bianqian',
    component: Bianqian,
  },
  {
    path: '/Page_shangpinxiangqingyemianbeifen',
    name: 'Page_shangpinxiangqingyemianbeifen',
    component: Page_shangpinxiangqingyemianbeifen,
  },
  {
    path: '/Page_shangpinxiangqingyemian',
    name: 'Page_shangpinxiangqingyemian',
    component: Page_shangpinxiangqingyemian,
  },
  {
    path: '/Page_huiyuankaitongyemianbeifen_3',
    name: 'Page_huiyuankaitongyemianbeifen_3',
    component: Page_huiyuankaitongyemianbeifen_3,
  },
  {
    path: '/Page_huiyuankaitongyemianbeifen_2',
    name: 'Page_huiyuankaitongyemianbeifen_2',
    component: Page_huiyuankaitongyemianbeifen_2,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;